import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,[_c(VCardTitle,[_vm._v("Rekapan Anulir Siswa")]),_c(VCardText,[_c('form',{on:{"submit":function($event){$event.preventDefault();return (() => {
          _vm.options.page = _vm.filter.page = 1;
          _vm.get();
        }).apply(null, arguments)}}},[_c(VRow,[_c(VCol,{attrs:{"lg":"12","cols":"12"}},[_c(VBtn,{attrs:{"role":"a","target":"_blank","href":_vm.pdf_url,"text":"","color":"red","dark":""}},[_vm._v(" Export PDF ")])],1),_c(VCol,{attrs:{"lg":"3","cols":"6"}},[_c(VAutocomplete,{attrs:{"label":"Rombel","items":_vm.data.rombel,"rules":[(v) => !!v || 'Silahkan pilih rombel'],"clearable":"","error":!!!_vm.filter.rombel_id,"hint":"Silahkan pilih rombel"},on:{"change":() => {
                _vm.options.page = _vm.filter.page = 1;
                _vm.get();
              }},model:{value:(_vm.filter.rombel_id),callback:function ($$v) {_vm.$set(_vm.filter, "rombel_id", $$v)},expression:"filter.rombel_id"}})],1),_c(VCol,{attrs:{"lg":_vm.filter.semester == '0' ? 3 : 5,"cols":"6"}},[_c(VSelect,{attrs:{"items":[
              {
                value: '1',
                text: 'Ganjil (Juli - Desember)',
              },
              {
                value: '2',
                text: 'Genap (Januari - Juni)',
              },
              {
                value: '0',
                text: 'Lainnya / Per-Bulan',
              },
            ],"label":"Semester","rules":[(v) => !!v || 'Silahkan pilih opsi semester'],"error":!!!_vm.filter.semester,"hint":"Silahkan pilih opsi semester"},on:{"change":function($event){_vm.options.page = _vm.filter.page = 1;
              _vm.get();}},model:{value:(_vm.filter.semester),callback:function ($$v) {_vm.$set(_vm.filter, "semester", $$v)},expression:"filter.semester"}})],1),(_vm.filter.semester == '0')?_c(VCol,{attrs:{"cols":"6","lg":"3"}},[_c(VSelect,{attrs:{"label":"Bulan","placeholder":"Pilih Bulan","rules":[(v) => !!v || 'bulan harus dipilih'],"items":_vm.data.bulan},on:{"input":() => {
                _vm.options.page = _vm.filter.page = 1;
                _vm.get();
              }},model:{value:(_vm.filter.bulan),callback:function ($$v) {_vm.$set(_vm.filter, "bulan", $$v)},expression:"filter.bulan"}})],1):_vm._e(),_c(VCol,{attrs:{"cols":_vm.filter.semester == '0' ? 6 : 12,"lg":_vm.filter.semester == '0' ? 3 : 4}},[_c(VTextField,{attrs:{"type":"number","label":"Tahun","placeholder":"Pilih Tahun","rules":[(v) => !!v || 'tahun harus dipilih']},on:{"change":() => {
                _vm.options.page = _vm.filter.page = 1;
                _vm.get();
              }},model:{value:(_vm.filter.tahun),callback:function ($$v) {_vm.$set(_vm.filter, "tahun", $$v)},expression:"filter.tahun"}})],1)],1),_c('button',{attrs:{"type":"submit"}})],1),_c(VDataTable,{attrs:{"footer-props":{
        'items-per-page-options': [5, 10, 20, 50, 100],
      },"disable-sort":"","headers":[
        {
          text: 'Tanggal',
          value: 'tanggal',
        },
        {
          text: 'NIS',
          value: 'siswa.nis',
        },
        {
          text: 'Nama',
          value: 'siswa.nama',
        },
        {
          text: 'Rombel',
          value: 'siswa_rombel',
        },
        {
          text: 'Keterangan',
          value: 'keterangan',
        },
      ],"items":_vm.datas,"loading":_vm.is.loading,"loading-text":"Loading... Please wait","server-items-length":_vm.recordsTotal,"options":_vm.options},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item.siswa_rombel",fn:function({ item }){return [_vm._v(" "+_vm._s(item.siswa ? item.siswa.rombel.rombel : "")+" ")]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }